var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isMobile
      ? _c(
          "div",
          [
            _vm.subStep == 1
              ? _c("div", { staticClass: "container-input" }, [
                  _c("div", { staticClass: "input-header" }, [
                    _c("strong", [
                      _vm._v(
                        "Etapa 1 de " +
                          _vm._s(_vm.nRootSteps) +
                          " - Escolha a quantidade de pessoas"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-body" },
                    [
                      _vm._l(_vm.options, function (option) {
                        return _c(
                          "div",
                          { key: option.id, staticClass: "faixa-option" },
                          [
                            _c("div", { staticClass: "faixa-option-info" }, [
                              _c("strong", [_vm._v(_vm._s(option.nome))]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("(" + _vm._s(option.descricao) + ")"),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "faixa-option-quantity",
                                attrs: { translate: "no" },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-minus",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sub(option)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "faixa-option-quantity-display",
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.getCurrentQuantidade(option))
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa-solid fa-plus",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.add(option)
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            visibility: _vm.isDependentOnly
                              ? "visible"
                              : "hidden",
                          },
                        },
                        [
                          _c("small", [
                            _vm._v(
                              "É necessário adicionar ao menos 1 não dependente"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.minVenda > 1 || _vm.maxVenda < Infinity
                        ? _c("div", { staticClass: "compliance-alert" }, [
                            _vm.minVenda > 1 && _vm.maxVenda < Infinity
                              ? _c("small", [
                                  _vm._v(
                                    "\n            O máximo de vagas para a compra desse combo por pessoa é: " +
                                      _vm._s(_vm.maxVenda) +
                                      " (caso tenha\n            disponibilidade). E no mínimo " +
                                      _vm._s(_vm.minVenda) +
                                      ".\n          "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.minVenda <= 1 && _vm.maxVenda < Infinity
                              ? _c("small", [
                                  _vm._v(
                                    "\n            O máximo de vagas para a compra desse combo por pessoa é: " +
                                      _vm._s(_vm.maxVenda) +
                                      " (caso tenha\n            disponibilidade).\n          "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.minVenda > 1 && _vm.maxVenda == Infinity
                              ? _c("small", [
                                  _vm._v(
                                    "\n            O mínimo de vagas para a compra desse combo por pessoa é: " +
                                      _vm._s(_vm.minVenda) +
                                      " (caso tenha\n            disponibilidade).\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.subStep == 2,
                    expression: "subStep == 2",
                  },
                ],
              },
              [
                _c("div", { staticClass: "input-header" }, [
                  _c("strong", [
                    _vm._v(
                      "\n          Etapa 2 de " +
                        _vm._s(_vm.nRootSteps) +
                        " - Escolha a data para as " +
                        _vm._s(_vm.nActivities) +
                        " atividades\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.onlySameDate
                  ? _c("input-data-calendario", {
                      attrs: {
                        "passeio-id": _vm.comboId,
                        "is-combo": true,
                        "initial-available-days": _vm.initialAvailableDays,
                        "calendar-size": _vm.calendarSizeParsed,
                        "start-opened": true,
                      },
                      on: { "on-open-change": _vm.heightChange },
                      model: {
                        value: _vm.selectedDate,
                        callback: function ($$v) {
                          _vm.selectedDate = $$v
                        },
                        expression: "selectedDate",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("nav-buttons", {
              style: { "margin-top": _vm.isMobile ? "0px" : "20px" },
              attrs: {
                "disable-previus": _vm.subStep <= 1 && !_vm.isMobile,
                "disable-next": !_vm.canGoNext,
                "is-mobile": _vm.isMobile,
                moeda: _vm.moeda,
                "sub-total": _vm.subTotal,
              },
              on: { next: _vm.next, previus: _vm.previus },
            }),
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.subStep == 1,
                    expression: "subStep == 1",
                  },
                ],
              },
              [
                _c("div", { staticClass: "input-header" }, [
                  _c("strong", [
                    _vm._v(
                      "Etapa 1 de " +
                        _vm._s(_vm.nRootSteps) +
                        " - Escolha a quantidade de pessoas"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm.options.length <= 0
                    ? _c("i", [_vm._v("Nenhuma classificação disponível")])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm._l(_vm.options, function (option, i) {
                  return _c(
                    "div",
                    {
                      key: option.id,
                      staticClass: "faixa-mobile-option",
                      style: {
                        "border-bottom":
                          i >= _vm.options.length - 1
                            ? "1px solid #CCCCCC"
                            : null,
                      },
                    },
                    [
                      _c("div", { staticClass: "faixa-mobile-option-info" }, [
                        _c("strong", [_vm._v(_vm._s(option.nome))]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("(" + _vm._s(option.descricao) + ")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "faixa-mobile-option-quantity",
                          attrs: { translate: "no" },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-solid fa-minus",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.sub(option)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "faixa-mobile-option-quantity-display",
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.getCurrentQuantidade(option))
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa-solid fa-plus",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.add(option)
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    style: {
                      visibility: _vm.isDependentOnly ? "visible" : "hidden",
                    },
                  },
                  [
                    _c("small", [
                      _vm._v(
                        "É necessário adicionar ao menos 1 não dependente"
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.minVenda > 1 || _vm.maxVenda < Infinity
                  ? _c("div", { staticClass: "compliance-alert" }, [
                      _vm.minVenda > 1 && _vm.maxVenda < Infinity
                        ? _c("small", [
                            _vm._v(
                              "\n          O máximo de vagas para a compra desse combo por pessoa é: " +
                                _vm._s(_vm.maxVenda) +
                                " (caso tenha\n          disponibilidade). E no mínimo " +
                                _vm._s(_vm.minVenda) +
                                ".\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.minVenda <= 1 && _vm.maxVenda < Infinity
                        ? _c("small", [
                            _vm._v(
                              "\n          O máximo de vagas para a compra desse combo por pessoa é: " +
                                _vm._s(_vm.maxVenda) +
                                " (caso tenha\n          disponibilidade).\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.minVenda > 1 && _vm.maxVenda == Infinity
                        ? _c("small", [
                            _vm._v(
                              "\n          O mínimo de vagas para a compra desse combo por pessoa é: " +
                                _vm._s(_vm.minVenda) +
                                " (caso tenha\n          disponibilidade).\n        "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.subStep == 2,
                    expression: "subStep == 2",
                  },
                ],
              },
              [
                _c("div", { staticClass: "input-header" }, [
                  _c("strong", [
                    _vm._v(
                      "\n          Etapa 2 de " +
                        _vm._s(_vm.nRootSteps) +
                        " - Escolha a data para as " +
                        _vm._s(_vm.nActivities) +
                        " atividades\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.onlySameDate
                  ? _c("input-data-calendario", {
                      attrs: {
                        "passeio-id": _vm.comboId,
                        "initial-available-days": _vm.initialAvailableDays,
                        "calendar-size": _vm.calendarSizeParsed,
                        "start-opened": true,
                        "is-combo": true,
                      },
                      on: { "on-open-change": _vm.heightChange },
                      model: {
                        value: _vm.selectedDate,
                        callback: function ($$v) {
                          _vm.selectedDate = $$v
                        },
                        expression: "selectedDate",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("nav-buttons", {
              style: { "margin-top": _vm.isMobile ? "0px" : "20px" },
              attrs: {
                "disable-previus": _vm.subStep <= 1 && !_vm.isMobile,
                "disable-next": !_vm.canGoNext,
                "is-mobile": _vm.isMobile,
                moeda: _vm.moeda,
                "sub-total": _vm.subTotal,
              },
              on: { next: _vm.next, previus: _vm.previus },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }